import { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { champPath, profiles } from "../misc/Static";
import Augment from "../images/Augment";
import Champ from "../images/Champ";
import Item from "../images/Item";
import calcData from "../memos/calcData";
import calcArena from "../memos/calcArena";
import Tip from "../misc/Tip";
import MatchArenaDetails from "./MatchArenaDetails";
import styles from "./MatchArena.module.css";

export const MatchArena = ({ region, puuid, data, width }) => {
  console.log(data)
  const [active, setActive] = useState(false);
  if (!data.placement) return <></>;
  const pid = data ? data.puuid.indexOf(puuid) : false;
  const pOrder = calcArena(data.placement);
  const calc = calcData(data, pOrder, pid, profiles.queues);
  const expandMatch = () => {
    setActive(!active);
  };
  return (
    <>
      <div className={styles[calc.result]}>
        <div className={styles[width]}>
          <div class={styles.metawrap}>
            <div className={styles.meta}>
              <div>{Math.round(data.duration / 60)} min</div>
              <div>{calc.queue}</div>
              <div>{["1st", "2nd", "3rd", "4th","5th","6th","7th","8th"][data.placement[pid] - 1]}</div>
              <div>{calc.time}</div>
            </div>
          </div>
          <div className={styles.champcol}>
            <a
              href={
                "https://lolalytics.com/lol/" +
                champPath(data.champion[pid]) +
                "/build/"
              }
            >
              <Champ type="champ50b" id={data.champion[pid]} />
            </a>
            <div className={styles.level}>{data.champLevel[pid]}</div>
          </div>
          <div className={styles.killstats}>
            <div>
              <div>
                <Tip name="kills">
                  <span className={styles.kills}>{data.kills[pid]}</span>
                </Tip>
                /
                <Tip name="deaths">
                  <span className={styles.deaths}>{data.deaths[pid]}</span>
                </Tip>
                /
                <Tip name="assists">
                  <span className={styles.assists}>{data.assists[pid]}</span>
                </Tip>
              </div>
              <div className={styles.kda}>
                <Tip name="kda">
                  {calc.kda[pid]}
                  {calc.kda[pid] !== "PERFECT" && <> KDA</>}
                </Tip>
              </div>
            </div>
          </div>
          <div className={styles.augment}>
            <div>
              {[0, 1].map((x) => (
                <div key={x}>
                  {[0, 1].map((y) => (
                    <div key={y}>
                      <Augment
                        augment={data[`augment${x * 2 + y + 1}`][pid]}
                        size="24"
                      />
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
          <div className={styles.itemsplus}>
            <div>
              <div class={styles.items}>
                {data.items[pid] &&
                  [0, 1, 2, 6, 3, 4, 5].map((item, i) => (
                    <Fragment key={item}>
                      {data.items[pid][item] === 0 && (
                        <div className={styles.placeholder24}></div>
                      )}
                      {data.items[pid][item] > 0 && (
                        <Item key={i} type="item24r" id={data.items[pid][item]} />
                      )}
                    </Fragment>
                  ))}
              </div>
              {calc.mmmrTier && (
                <div class={styles.mmr}>
                  <Tip name="elo">
                    <img
                      src={`https://cdn5.xdx.gg/emblem32/${calc.mmmrTier.toLowerCase()}.webp`}
                      srcSet={`https://cdn5.xdx.gg/emblem32/${calc.mmmrTier.toLowerCase()}.webp 32w,
                              https://cdn5.xdx.gg/emblem64/${calc.mmmrTier.toLowerCase()}.webp 64w,
                              https://cdn5.xdx.gg/emblem96/${calc.mmmrTier.toLowerCase()}.webp 96w`}
                      width="32"
                      height="32"
                      alt={calc.mmmrTier.toLowerCase()}
                    />
                  </Tip>
                  <div>
                    <Tip name="elo">
                      {calc.mmmrTier} {calc.mmmrDivision}
                      <br />
                      {calc.mmmrLP} LP
                    </Tip>
                  </div>
                </div>
              )}
            </div>
          </div>
          {width !== "xsmall" && (
            <div className={styles.tally}>
              <div class={styles.gold}>
                <Tip name="goldearned">
                  {data.goldEarned[pid] &&
                    data.goldEarned[pid].toLocaleString()}
                  <img
                    data-type="tip"
                    data-id="goldearned"
                    src="https://cdn5.xdx.gg/icons/gold.webp"
                    alt="Gold"
                  />
                </Tip>
              </div>
            </div>
          )}
          {[0, 1].map((x) => (
            <div className={styles.summonerwrap} key={x}>
              {[0,1,2,3].map((y) => (
                <div key={y}>
                  {[0, 1].map((z) => (
                    <div className={styles.summoner} key={z}>
                      <Link to={data.pathName[x * 4 + y * 2 + z]}>
                        <Champ
                          type="champ20b"
                          id={data.champion[x * 4 + y * 2 + z]}
                        />
                        <div className={styles.name}>
                          {data.summonerName[x * 4 + y * 2 + z]}
                        </div>
                      </Link>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          ))}
          <div className={styles.expand} onClick={expandMatch}>
            <div>{active ? "-" : "+"}</div>
          </div>
        </div>
      </div>
      {active && (
        <MatchArenaDetails
          region={region}
          pid={pid}
          match={data}
          order={pOrder}
          calc={calc}
          width={width}
        />
      )}
    </>
  );
};

export default MatchArena;
